import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FaSearch, FaBell, FaUserCircle, FaCalendarAlt } from "react-icons/fa";
import { BsChatDots } from "react-icons/bs";
import { IoMdSend } from "react-icons/io";
import moment from "moment";
import { IoArrowBackCircleSharp } from "react-icons/io5";
import { getChatUserDetailsAPI } from '../../serverApi/server'
import AdminChatPage from './AdminChatPage'


const ChatDashboard = () => {
  const navigate = useNavigate();
  const [sessionId, setSessionId] = useState('')
  const [customers, setCustomers] = useState([])
  const [currentCustomer, setCurrentCustomer] = useState({})
  const [currentCustomerMessage, setCurrentCustomerMessage] = useState('')

  const changeCustomerChat = (SelectedSessionId, customer) => {
    setSessionId(SelectedSessionId);
    setCurrentCustomer(customer)
  }

  useEffect(() => {
    let socket = null;
    let reconnectTimeout = null;
    let shouldReconnect = true;

    const connectWebSocket = () => {
      socket = new WebSocket('wss://www.stalbansprinting.com/ws/chat_user_summary/');

      socket.onopen = () => {
        console.log("✅ WebSocket connected");
      };

      socket.onmessage = (event) => {
        const data = JSON.parse(event.data);
        if (data.type === 'chat_user_summary') {
          const sortedCustomers = data.chat_user_details.sort(
            (a, b) => new Date(b.created_at) - new Date(a.created_at)
          );
          setCustomers(sortedCustomers);
        }
      };

      socket.onerror = (error) => {
        console.error("❌ WebSocket error:", error);
        // socket.close(); // Force close to trigger reconnect
      };

      socket.onclose = (e) => {
        console.warn("⚠️ WebSocket closed:", e);
        if (shouldReconnect) {
          console.log("🔁 Attempting to reconnect in 3 seconds...");
          reconnectTimeout = setTimeout(connectWebSocket, 3000);
        }
      };
    };

    connectWebSocket();

    const pingInterval = setInterval(() => {
      if (socket?.readyState === WebSocket.OPEN) {
        socket.send(JSON.stringify({ type: 'ping' }));
      }
    }, 3000);

    return () => {
      shouldReconnect = false; // Prevent reconnect after unmount
      clearInterval(pingInterval);
      clearTimeout(reconnectTimeout);
      // socket?.close();
    };
  }, []);

  useEffect(()=>{
    setCustomers((prevCustomers) =>
      prevCustomers.map((customer) =>
        customer.session_id === sessionId
          ? { ...customer, unread_count: 0 }
          : customer
      )
    );
  }, [sessionId])

  console.log('\n customers ===================>: ', customers)

  const getFormattedTime = (timestamp) => {
    const estDate = new Date(new Date(timestamp).toLocaleString("en-US", { timeZone: "America/New_York" }));
    const now = new Date(new Date().toLocaleString("en-US", { timeZone: "America/New_York" }));
    const isToday = estDate.toDateString() === now.toDateString();
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);
    const isYesterday = estDate.toDateString() === yesterday.toDateString();
    if (isToday) {
      return estDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
    } else if (isYesterday) {
      return "Yesterday";
    } else {
      return estDate.toLocaleDateString("en-US");
    }
  };

  return (
    <div className="flex h-screen bg-[#0b1437] text-white font-sans">
      <div className="w-64 border-r border-gray-700 bg-[#0e1b4d] flex flex-col">
        <div className="p-4 text-xl font-bold border-b border-gray-700 flex items-center gap-2">
          <IoArrowBackCircleSharp onClick={()=>navigate('/admin/dashboard')} className="text-yellow-400 cursor-pointer" size={32} /> Back
        </div>
        <div className="flex flex-col divide-y divide-gray-700 overflow-y-auto pr-1 custom-scrollbar">
          {customers.map((customer, i) => {
            const isActive = sessionId === customer.session_id;
            return (
              <div
                key={customer.session_id}
                className={`p-4 hover:bg-[#192655] cursor-pointer ${isActive ? 'bg-[darkslateblue]' : ''}`}
                onClick={() => changeCustomerChat(customer.session_id, customer)}
              >
                <div className="font-medium text-sm">{customer.user_full_name ? customer.user_full_name : customer.chat_user_id ? `New User - ${customer.chat_user_id}` : customer.session_id}</div>
                <div className="flex justify-between items-center mt-1">
                  <div className="text-xs text-gray-400 truncate max-w-[80%]">
                    {customer.message}
                  </div>
                  {customer.unread_count > 0 && (
                    <div className="bg-green-500 text-white text-xs font-semibold rounded-full w-5 h-5 flex items-center justify-center ml-2">
                      {customer.unread_count}
                    </div>
                  )}
                </div>
                <div className="text-xs text-right text-gray-500">{getFormattedTime(customer.created_at)}</div>
              </div>
            );
          })}
        </div>
      </div>
      <AdminChatPage 
        sessionId={sessionId} 
        currentCustomer={currentCustomer} 
        setCurrentCustomerMessage={setCurrentCustomerMessage} 
        customers={customers}
      />
      <div className="w-72 border-l border-gray-700 bg-[#0e1b4d] p-4">
        <div className="flex text-lg font-semibold mb-4"><BsChatDots className="text-yellow-400" size={24} /><p className="ml-[10px]">Chat Bot</p></div>
        <div className="bg-[#1b2a5e] p-4 rounded-lg text-center mb-4">
          <FaCalendarAlt className="mx-auto mb-2" size={24} />
          <div>{moment().format("MMMM YYYY")}</div>
          <div className="mt-2 text-sm text-gray-400">27 May 2025</div>
        </div>
        {/* <div className="space-y-2 text-sm">
          <div className="bg-[#1b2a5e] p-2 rounded">8 March – Main basket bersama muhammad fauzi</div>
          <div className="bg-[#1b2a5e] p-2 rounded">9 March – Deadline project desain aplikasi $5000</div>
          <div className="bg-[#1b2a5e] p-2 rounded">10 March – Meeting ITone persiapan lomba website...</div>
        </div> */}
      </div>
    </div>
  );
};

export default ChatDashboard;

